import React from "react";
import { Helmet } from "react-helmet";
import { NavLink } from 'react-router-dom';


function MediumLinks(props)
{
    var URL_PREFIX = "https://webcache.googleusercontent.com/search?q=cache:";

    function processURL()
    {
        var URL_REQUESTED = document.getElementById("link").value;
        console.log(URL_PREFIX + URL_REQUESTED)
        window.open(URL_PREFIX + URL_REQUESTED + "&strip=1", "_blank");
        //global.window && (global.window.location.href = URL_PREFIX + URL_REQUESTED);
        //return;
        return;
    }

    return (
        <div>
            <Helmet>
                <title>Medium pages reader | Lucas RODRIGUEZ</title>
                <meta name="description" content="Contact page of Lucas RODRIGUEZ" />
            </Helmet>
            <h2>Medium pages reader</h2>
            <p>
                Please provide a valid <a href="https://medium.com">medium.com</a> or <a href="https://towardsdatascience.com">towardsdatascience.com</a> links.
            </p>


            <hr class="col-3 col-md-2 mb-5" />

            <div className="row">
                <div className="col-sm-9">
                    <form onSubmit={processURL}>
                        <div class="input-group input-group-lg">
                            <input class="form-control" id="link" name="link" type="text" placeholder="Medium or Toward Data Science link" autoFocus />
                        </div>
                        <button class="btn btn-dark btn-block mt-3" style={{ width: "100%" }}><span class="fa fa-link"></span>&nbsp;&nbsp;Access</button>
                    </form>
                </div>
            </div>
        </div>
    );
}
export default MediumLinks;